import React from 'react';

const TnC = () => {
  return (
    <div className='text-white font-sant-serif poppins'>
      {/* Section 01 / Introduction */}
      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">01 / Introduction</p>
        <p className="leading-8 my-2">Welcome to PYREXIA 2025! </p>
        <p className="leading-8 my-2">
        These terms and conditions outline the rules and regulations for the use of PYREXIA 2025's Website.
        </p>
        <p className="leading-8 my-6">
          All communication will be done through our{' '}
          <span className="font-semibold text-rose-500">Instagram page</span>. You must follow our page and view regular
          updates there. Our Instagram page is here:{' '}
          <a href="https://www.instagram.com/pyrexiaaiims?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" className="text-blue-500 hover:underline">
          https://www.instagram.com/pyrexiaaiims?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==..
          </a>.
        </p>
        <p className="leading-8 my-6">
          We PYREXIA 2025, AIIMS Rishikesh, are not responsible if you miss any of the communication posted there.
        </p>
        <p className="leading-8 my-6">
          By accepting terms and conditions anywhere on our website, you confirm that you followed our Instagram page.
        </p>
        <p className="leading-8 my-6">
          The terms "Client", "You" and "Your" refer to the user who accesses this website. This terminology also applies
          to all agreements: the "Terms and Conditions'', the "Privacy Statement", the "Disclaimer Notice", and all
          related documents. Our organization is referred to as "PYREXIA, AIIMS Rishikesh", "Ourselves", "We", "Ours'' and
          "Us". The terms "Party", "Parties" or "Us" include both the user and us. All phrases refer to the provision of
          our support to the client in the most effective manner for the specific goal of addressing that client's needs
          in relation to the rendering of the organization's stated services. Any usage of the aforementioned terminology
          or other words in the singular, plural, he/she or they format is understood to be interchangeable and to be
          referring to the same.
        </p>
        <p className="leading-8 my-2">
        By accessing this website, we assume you accept these terms and conditions. Do not continue to use PYREXIA 2025 if you do not agree to take all of the terms and conditions stated on this page. 
          if you do not agree to take all of the terms and conditions stated on this page.
        </p>
      </div>

      {/* Section 02 / Cookies */}
      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">02 / Cookies</p>
        <p className="leading-8 my-6">
          We use cookies in our operations. You accepted to use cookies in accordance with PYREXIA 2025's privacy policy by browsing the website. 
          
        </p>
        <p className="leading-8 my-6">
          Cookies are used by the majority of interactive websites to allow us to retrieve user information for each visit. Our website uses cookies to enhance the functionality of some areas so that users can navigate it more easily. Cookies may also be used by some of our affiliate and advertising partners. 
        </p>
      </div>

      {/* Section 03 / Privacy Policy */}
      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">03 / Privacy Policy</p>
        <p className="leading-8 my-2">
         All content on PYREXIA 2025 is the exclusive property of PYREXIA 2025 and/or its licensors, unless otherwise noted. The ownership of every intellectual property is reserved. Subject to the limitations set forth in these terms and conditions, you are permitted to access this from PYREXIA 2025 for your own personal use. 
        
        </p>
        <p className="leading-8 my-2">You must not:</p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-2">Replicate PYREXIA 2025 content </li>
          <li className="leading-8 my-2">Sell, rent, or sublicense PYREXIA 2025 content </li>
          <li className="leading-8 my-2">Copy or reproduce PYREXIA 2025 materials </li>
          <li className="leading-8 my-2">Republish articles from PYREXIA 2025 </li>
        </ul>
        <p className="leading-8 my-6">
           This Agreement shall take effect on the date hereof. On several pages of this website, users have the option to publish messages and engage in information and opinion exchanges. Before they appear on the website, comments are not filtered, edited, published, or reviewed by PYREXIA 2025. The views and opinions expressed in the comments do not represent those of PYREXIA 2025, its affiliates, or its agents. The views and opinions expressed in comments are those of the commenter. PYREXIA 2025 shall not be liable for the Comments or for any liabilities, damages, or expenses caused and/or suffered as a result of any use of, publication, or appearance of the Comments on this website, to the fullest extent permitted by applicable laws. 
          
        </p>
        <p className="leading-8 my-6">
          
          PYREXIA 2025 retains the right to review all comments and to remove any Comments that are objectionable, offensive, or otherwise in violation of our terms and conditions. You guarantee and affirm that: 
        </p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-2">The Comments do not violate any intellectual property rights, including without limitation copyright, patent, or trademark of any third party;  </li>
          <li className="leading-8 my-2">You are authorized to post the Comments on our website and have all required permissions and licenses to do so;  </li>
          <li className="leading-8 my-2">The Comments don't contain any information that is an invasion of privacy or is slanderous, inflammatory, or libelous; </li>
          <li className="leading-8 my-2">The Comments won't be used to advertise, solicit, or promote any kind of trade, custom, company, or illegal action.  </li>
        </ul>
        <p className="leading-8 my-6"></p>
        By submitting your comments, you give PYREXIA 2025 a non-exclusive right to use, reproduce, alter, and give others permission to do the same in any and all forms, formats, or media. 
        <p/>
      </div>

      {/* Section 04 / Hyperlinking */}
      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">04 / Hyperlinking to our Content</p>
        <p className="leading-8 my-2">
          The following organizations may link to our website without prior written approval:
        </p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-2">Government agencies</li>
          <li className="leading-8 my-2">Search engines</li>
          <li className="leading-8 my-2">News organizations</li>
          <li className="leading-8 my-2">
            Distributors of online directories may link to our website in the same way they connect to the websites of
            other businesses featured in the directory,except for soliciting non-profit organizations. 
          </li>
          <li className="leading-8 my-2">
            Charity shopping centers and fundraising organizations are not permitted to link to our website.
          </li>
        </ul>
        <p className="leading-8 my-6">
          These groups are permitted to link to our home page, publications, or other website content as long as the link
          satisfies the following criteria:
        </p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-2">The link is not in any way misleading</li>
          <li className="leading-8 my-2">
            It does not imply sponsorship, endorsement, or approval of the aligned party and its goods and/or services; 
          </li>
          <li className="leading-8 my-2">The link does not imply that we are affiliated with the organization; </li>
          <li className="leading-8 my-2">The organization does not have a bad reputation with us</li>
          <li className="leading-8 my-2">The link is in the context of general resource information. </li>
        </ul>
        <div className="pb-10">
  <p className="leading-8 text-opacity-60 font-normal my-3">02 / Linking Policy</p>
  <p className="leading-8 my-6">
    Other link requests from the following categories of organizations may be taken into consideration and approved:
    <ul className="list-disc pl-6">
      <li>Sources of information used often by consumers and/or businesses</li>
      <li>Web-based communities</li>
      <li>Associations or other organizations that speak for charities</li>
      <li>Online directory distributors</li>
      <li>Internet portals</li>
      <li>Accounting, law, and consulting firms</li>
      <li>Commercial associations and educational institutes</li>
    </ul>
  </p>
  <p className="leading-8 my-6">
    Requests for links from these organizations will be approved if we determine that:
    <ul className="list-disc pl-6">
      <li>The link wouldn't reflect poorly on us or the firms we've accredited</li>
      <li>There are no disciplinary records against the organization with us</li>
      <li>
        The benefit to us from the hyperlink's visibility more than makes up for PYREXIA 2025's absence
      </li>
      <li>The link is included in a generic resource information context</li>
    </ul>
  </p>

  <p className="leading-8 my-6">
    These businesses are permitted to link to our main page provided that the link:
    <ul className="list-disc pl-6">
      <li>Is not false in any way</li>
      <li>Does not represent or imply sponsorship, endorsement, or approval</li>
      <li>Fits the theme of the website of the linking party</li>
    </ul>
  </p>
  <p className="leading-8 my-6">
    Send an email to PYREXIA, AIIMS Rishikesh if you represent one of the organizations named above and are interested in linking to our website.
  </p>
  <p className="leading-8 my-6">
    Organizations that have been approved may link to our website in the following ways:
    <ul className="list-disc pl-6">
      <li>By utilizing our company name</li>
      <li>By utilizing the URL that is being linked to</li>
      <li>Using relevant terminology to describe our website</li>
    </ul>
  </p>
  <p className="leading-8 my-6">
    Absent a trademark license agreement, no use of the PYREXIA, AIIMS Rishikesh logo or any works of art may be made for linking purposes.
  </p>
  </div><div>
  <p className="leading-8 text-opacity-60 font-normal my-3">05 / Frames</p>
  <p className="leading-8 my-6">
    You may not include anything into our Web Pages that changes the visual presentation or appearance of our Website inside frames without our express prior written consent.
  </p>
  </div><div>
  <p className="leading-8 text-opacity-60 font-normal my-3">06 / Content Liability</p>
  <p className="leading-8 my-6">
    Anything that appears on your website is not our responsibility. You promise to defend us from any allegations made against us on your website. No link(s) that could be construed as defamatory, obscene, or illegal should be included on any website. Neither should any link(s) that violate third-party rights or that support their infringement or other violations.
  </p>
  </div><div>
  <p className="leading-8 text-opacity-60 font-normal my-3">07 / Reservation & Rights</p>
  <p className="leading-8 my-6">
    We have the right to ask you to take down any link to our website or all links. You consent to our right to request the immediate removal of any connections to our website. Furthermore, we reserve the right to update these terms and conditions as well as our linking policy at any time. You agree to be governed by and comply with these linking terms and conditions if you link to our website on a regular basis.
  </p>
  </div><div>
  <p className="leading-8 text-opacity-60 font-normal my-3">08 / Disclaimer</p>
  <p className="leading-8 my-6">
    We disclaim any and all representations, warranties, and conditions with regard to our website and the use of our website to the fullest extent authorized by law. This disclaimer in no way:
    <ul className="list-disc pl-6">
      <li>Limits or excludes both our and your responsibility for wrongful harm resulting</li>
      <li>Limits or excludes both our and your responsibility for wrongful harm resulting</li>
    </ul>
  </p>
  <p className="leading-8 my-6">
  The restrictions and prohibitions of liability set forth in this section and elsewhere in this disclaimer: (a) are subject to the previous sentence; and (b) govern any liabilities emerging under the disclaimer, including liabilities originating in contract, negligence, or any other form.  </p>
</div>

      </div>

      {/* Continue sections similarly... */}
    </div>
  );
};

export default TnC;